import React, { useState, useEffect } from "react";
import { Heart, Star, MapPin, Clock, ArrowRight, Sparkles } from "lucide-react";
import "./TrendingHoneymoonPackages.css";

const API_URL = "https://admin.jayrajgroup.com/api/honeymoon/packages";

const TrendingHoneymoonPackages = () => {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [wishlist, setWishlist] = useState({});

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const response = await fetch(API_URL);
        const result = await response.json();
        if (result.status && Array.isArray(result.data)) {
          setPackages(result.data);
        }
      } catch (error) {
        console.error("Error fetching honeymoon packages:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPackages();
  }, []);

  const toggleWishlist = (id) => {
    setWishlist((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(price);
  };

  if (loading) {
    return (
      <div className="hpm-loading-wrapper">
        <div className="hpm-spinner-loader"></div>
      </div>
    );
  }

  return (
    <section className="hpm-packages-section">
      <div className="hpm-section-container">
        {/* Header */}
        <div className="hpm-header-group">
          <span className="hpm-eyebrow-badge">
            <Sparkles className="hpm-eyebrow-icon" /> HANDPICKED FOR YOU
          </span>
          <h2 className="hpm-main-heading">Trending Honeymoon Packages</h2>
          <p className="hpm-sub-heading">
            Unforgettable romantic journeys crafted for extraordinary beginnings and everlasting memories.
          </p>
        </div>

        {/* Package Grid */}
        <div className="hpm-cards-grid">
          {packages.map((pkg) => {
            const originalPrice = pkg.plans_starting_from * 1.25;
            const isLiked = !!wishlist[pkg.id];

            return (
              <div key={pkg.id} className="hpm-package-card">
                {/* Image Container */}
                <div className="hpm-media-frame">
                  <img
                    src={pkg.featured_photo_url}
                    alt={pkg.name}
                    className="hpm-cover-img"
                  />
                  <div className="hpm-badge-overlay-group">
                    <span className="hpm-chip hpm-chip-trending">Trending</span>
                    <span className="hpm-chip hpm-chip-discount">20% OFF</span>
                  </div>
                  <button
                    className={`hpm-like-toggle-btn ${isLiked ? "hpm-is-active" : ""}`}
                    onClick={() => toggleWishlist(pkg.id)}
                    aria-label="Add to wishlist"
                  >
                    <Heart className="hpm-heart-svg" />
                  </button>
                </div>

                {/* Card Body */}
                <div className="hpm-card-body">
                  <div className="hpm-meta-row">
                    <span className="hpm-location-tag">
                      <MapPin size={14} /> {pkg.destination?.name || "Global"}
                    </span>
                    <span className="hpm-rating-score">
                      <Star size={14} className="hpm-star-svg" /> 4.9
                    </span>
                  </div>

                  <h3 className="hpm-card-title">{pkg.name}</h3>

                  <div className="hpm-duration-info">
                    <Clock size={14} /> {pkg.duration_nights} Nights / {pkg.duration_days} Days
                  </div>

                  <ul className="hpm-perks-list">
                    <li>Luxury Resort Stay</li>
                    <li>Private Candlelit Dinner</li>
                    <li>Airport Transfers</li>
                  </ul>

                  {/* Footer & Pricing */}
                  <div className="hpm-card-footer">
                    <div className="hpm-price-block">
                      <div className="hpm-price-stack">
                        <span className="hpm-old-price">
                          {formatPrice(originalPrice)}
                        </span>
                        <span className="hpm-current-price">
                          {formatPrice(pkg.plans_starting_from)}
                        </span>
                      </div>
                      <span className="hpm-price-unit">per couple</span>
                    </div>

                    <a href={`/honeymoon/packages/${pkg.slug}`} className="hpm-action-link-btn">
                      View Details
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* View All CTA */}
        <div className="hpm-action-footer">
          <a href="/honeymoon/packages" className="hpm-view-all-cta">
            View All Packages <ArrowRight size={18} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default TrendingHoneymoonPackages;